module.exports = __webpack_public_path__ + "img/adf-navy.27040d4.webp";